import React, { Fragment } from 'react';
import Header from './components/Header';
import LandingContent from './components/LandingContent';
import SignupSection from './components/SignupSection';
import OnlyTextSection from './components/OnlyTextSection';
import AssessmentGraphicImg from '../../image/home/Swasth-provider-assessment-graphic.png';
import AppointmentGraphicImg from '../../image/home/appointment-graphic.png';
import EngageBetterGraphicImg from '../../image/home/engage-better@3x.png';
import EvidenceBasedGraphicImg from '../../image/home/Swasth-provider-evidence-based-graphic.png';
import GetPaidGraphicImg from '../../image/home/Get-paid-section@3x.png';
import TopBG from '../../image/home/top-bg@3x.png';
import GoPaperlessGraphicImg from '../../image/home/notes.png';
import ReachMoreClientsGraphicImg from '../../image/home/reach-more-clients-graphic@3x.png';
import BetterInsightsGraphicImg from '../../image/home/better-insights-graphic@3x.png';
import RemoteConsultantImg from '../../image/home/VIDEORemoteConsultant.png';
import ContentSection from './components/ContentSection';
import Footer from './components/Footer';

// const { Footer } = Layout;

function Home() {
  return (
    <div className='bt_portal-home'>
      <img
        src={TopBG}
        className='home-bg-img'/>
      <div className='landing_section centered-content'>
        <Header />
        <LandingContent />
      </div>
      <SignupSection />
      <OnlyTextSection />
      <ContentSection
        title={
          <Fragment>
            Multiple <span className='target-text'>Evidence-based</span> Therapy Apps
          </Fragment>
        }
        description={
          "As you know therapy is not one size fits all. Get your clients access to Resiliens's suite of evidence-based therapy apps (DBT Coach, CBT Companion, ACT Coach etc.) based on the treatment modality. With each of these apps clients can access an extensive library of digital therapy tools, including lessons, therapy specific exercises and with hours of guided psychoeducation and content using videos and fun animations.          "
        }
        image={EvidenceBasedGraphicImg}
      />
      <ContentSection
        leftSide
        title={
          <Fragment>
            Go <span className='target-text'>Paperless</span> With{' '}
            <span className='target-text -secondary'>Electronic Notes</span>
          </Fragment>
        }
        description='Send your clients mobile-friendly paperless intakes before their first visit. Use customizable templates for notes, forms, and assessments, and securely store documents          '
        image={GoPaperlessGraphicImg}
      />
      <ContentSection
        title={
          <Fragment>
            Better Insights With <span className='target-text'>360-Degree View </span>
            of Clients
          </Fragment>
        }
        description={
          "Real-time access to your clients’ actionable behavioral health data, including mood, emotions, diary card entries, exercises, practices, activities, clinical assessment results etc. The ability to track progress over time allows you to tailor treatments specific to the client's needs.          "
        }
        image={BetterInsightsGraphicImg}
      />
      <ContentSection
        leftSide
        title={
          <Fragment>
            Measure  <span className='target-text'> Outcomes </span> and get
            <span className='target-text'> Reimbursed</span>
          </Fragment>
        }
        description={
          "Easily track the client's progress between sessions with clinically proven assessments (PHQ-9, GAD-7 etc). Resiliens automatically engages with your clients, scores, analyzes and presents the results so you won't have to deal with the paperwork. The platform scores these automatically. Increase reimbursement up to an additional $24 per session, with a click of a button. "
        }
        image={AssessmentGraphicImg}
      />
      <ContentSection
        title={
          <Fragment>
            <span className='target-text'>Schedule</span> Appointments
          </Fragment>
        }
        description={
          "Use Online Booking to schedule appointments, send automated appointment reminders. Set your recurring availability and let clients request appointments in your Client Portal or on your website. You have full control over which times, services, and locations are available."
        }
        image={AppointmentGraphicImg}
      />
      <ContentSection
        leftSide
        title={
          <Fragment>
            <span className='target-text'>Engage</span> Better with Clients
          </Fragment>
        }
        description={
          "Assign homework, practice ideas, meditations and activities for your clients to do at home. You clients can complete them using Resiliens's mobile apps and share their data that you can see in real time.          "
        }
        image={EngageBetterGraphicImg}
      />
      <ContentSection
        title={
          <Fragment>
            <span className='target-text'>Remote</span> Consultation
          </Fragment>
        }
        description='Using our HIPAA compliant high definition teletherapy you can offer remote consultations for clients who cannot meet you physically. You can also communicate with your clients using our secure chat, answer questions etc.        '
        image={RemoteConsultantImg}
      />
      <ContentSection
        leftSide
        title={
          <Fragment>
            <span className='target-text'>Reach</span> More Clients
          </Fragment>
        }
        description={
          "List your profile on Resiliens's therapist directory and also get preferred listing for your specialties. Further, you get listed on top of search results if you are a Resiliens for clinicians user. By offering remote consultations we help you grow your practice."
        }
        image={ReachMoreClientsGraphicImg}
      />
     {/* <TeamMembers /> */}
      <Footer />
      {/* <Footer
        style={{
          background: 'transparent',
          textAlign: 'center',
          borderTop: '1px solid #ededed',
        }}
      >
        {siteConfig.footerText}
      </Footer> */}
    </div>
  );
}

export default Home;
